import React, { useState } from 'react';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';
import { Lock, Loader2 } from 'lucide-react';
import { useAuth, formatApiErrorDetail } from '../context/AuthContext';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Button } from '../components/ui/button';

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const redirectTo = location.state?.from || '/admin';

  if (user) return <Navigate to={redirectTo} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(form.email, form.password);
      navigate(redirectTo, { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-950 flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src="/logo.png" alt="iWurks360" className="h-14 mx-auto mb-4" onError={(e) => { e.currentTarget.style.display = 'none'; }} />
          <h1 className="text-3xl font-bold text-white" style={{ fontFamily: 'var(--font-serif)' }}>Admin Sign In</h1>
          <p className="text-gray-400 text-sm mt-2">Visitors, contacts and quotes are private to the iWurks360 team.</p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-2xl p-8 shadow-2xl space-y-5" data-testid="admin-login-form">
          <div className="space-y-1.5">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required autoComplete="username" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="login-email-input" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" required autoComplete="current-password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="login-password-input" />
          </div>
          {error && <p className="text-sm text-red-600" role="alert" data-testid="login-error">{error}</p>}
          <Button type="submit" disabled={loading} className="w-full text-white rounded-full py-5" style={{ backgroundColor: '#D97904' }} data-testid="login-submit-btn">
            {loading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Lock className="w-4 h-4 mr-2" />}
            Sign in
          </Button>
        </form>
      </div>
    </div>
  );
}
